<template>
  <div class="flex flex-row items-center gap-1">
    <template v-for="(lang, index) in Config.languages" :key="lang">
      <VaButton
        size="small"
        plain
        color="white"
        :style="lang === userStore.language ? 'font-weight: bold' : 'opacity: 0.7'"
        @click="switchLanguage(lang)"
      >
        {{ lang.toUpperCase() }}
      </VaButton>
      <span v-if="index < Config.languages.length - 1" class="opacity-50">|</span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { VaButton } from 'vuestic-ui'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/stores/UserStore'
import Config from '@/utils/config'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()

const switchLanguage = (lang: string) => {
  userStore.setLanguage(lang)
  if (route.params.locale) {
    router.replace({ params: { ...route.params, locale: lang } })
  }
}
</script>
